<template>
    <div id="engineerBasicPackage">
        <div class="basicPackage container">
            <span class="headerSpan" style="padding-bottom:10px;display:block">背包类型</span>
            <ul class="clearfix">
                <li v-for="(item,index) in basicPackageLists" :key="index" class="basicPackageListPart listPart"
                    @click="selectbasicPackage(item,index)">
                    {{item.packName}}
                    <span v-bind:class="{active:activeIndex===index}"><i class="el-icon-check"></i></span>
                    <span class="exitBtn" v-if="basicsAuth.packTypeEdit" @click.stop="exitbasicPackage(item)">编辑</span>
                    <i class="el-icon-error activeDelBtn" v-if="basicsAuth.delete_pack" @click.stop="deleteEngineerPack(item.id)"></i>
                </li>
                <li class="addContent" v-if="basicsAuth.packTypeAdd" @click="newbasicPackage()"><i class="el-icon-plus"></i></li>
            </ul>
            <el-dialog :title="textMenu[dialogMenuStatus]" :visible.sync="dislogbasicPackage" :close-on-click-modal="false" width="600px"  @close="emptyDialog('basicPackageForm')">
                <el-form ref="basicPackageForm" :model="basicPackageForm" label-width="120px" :label-position="labelPosition">
                    <el-form-item label="基础包名称：" prop="packName">
                        <el-input v-model.trim="basicPackageForm.packName" placeholder="请输入基础包名称(不超过20个字)" maxlength="20"></el-input>
                    </el-form-item>
                    <el-form-item label="启用状态：" prop="status">
                        <el-switch v-model="basicPackageForm.status" :active-value="1" :inactive-value="-1" ></el-switch>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer" >
                    <el-button v-if="dialogMenuStatus!=='update'" type="success" @click="addEventFormSubmitBtn('basicPackageForm')">添加</el-button>
                    <el-button v-else type="success" @click="saveEventFormSubmitBtn('basicPackageForm')">保存</el-button>
                    <el-button @click="emptyDialog('basicPackageForm')">取 消</el-button>
                </span>
            </el-dialog>
        </div>
        <el-row class="container-part2">
            <el-col>
                <span class="headerSpan">品牌</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li class="fl listPart" v-for="(item,index) in brandLists" :key="index" @click="selectBrand(item,index)" v-bind:class="{active:item.brandId === defaultBrandId}">{{item.brandName}}</li>
                </ul>
                <span class="headerSpan">品类</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li @click="selectCategoryOpe(item,index)" class="fl listPart" v-for="(item,index) in categoryLists" :key="index" v-bind:class="{active:item.categoryId === defaultCategoryId}">{{item.categoryName}}</li>
                </ul>
                <span class="headerSpan">型号</span>
                <ul class="clearfix" style="margin-bottom: 15px;">
                    <li v-for="(item,index) in modelLists" @change="changeModel()" :key="index" @click="selectModelOpe(item,index)" v-bind:class="{active:item.modelId === defaultModelId}" class="fl listPart" >{{item.modelName}}</li>
                </ul>
            </el-col>
        </el-row>
        <el-row class="container containerTable">
            <p>编辑基础物料</p>
            <el-button size="small" v-if="basicsAuth.packTypeEditByWs" type="primary" @click="exitMater()" style="margin: 10px 0;">{{exitHtml}}</el-button>
            <el-button type="text" v-if='showText' @click="newMater()">新增物料明细</el-button>
            <el-table
                :data="returnData"
                border
                :header-cell-style="{'text-align':'center'}"
                style="width: 800px;">
                <el-table-column
                    align="center"
                    prop="materialCode"
                    min-width="200"
                    label="物料编号">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="materialName"
                    width="200"
                    label="物料名称">
                </el-table-column>
                <el-table-column
                    align="center"
                    prop="sum"
                    width="250"
                    label="基础包数量">
                    <template slot-scope="scope">
                        <el-input type="number" style="border-color: transparent;" size="small" v-model.trim="scope.row.sum" :disabled="allowExit"></el-input>
                    </template>
                </el-table-column>
                <el-table-column
                    align="center"
                    label="操作"
                    v-if="exitStatus"
                    min-width="50">
                    <template slot-scope="scope">
                        <el-button @click.stop="deleteRow(scope.$index, returnData)" type="text" size="small">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-dialog title="新增物料" :visible.sync="dislogMater" :close-on-click-modal="false" width="700px">
                <el-table
                    :data="newData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @selection-change="handleSelectionChange">
                    <el-table-column
                        align="center"
                        prop="brandName"
                        label="品牌">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="categoryName"
                        label="品类">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        type="selection"
                        width="55">
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next,jumper"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
                <span slot="footer" class="dialog-footer" >
                    <el-button type="success" @click="addMaterSubmitBtn()">添加</el-button>
                    <el-button @click="emptyNewData()">取 消</el-button>
                </span>
            </el-dialog>
        </el-row>
  </div>
</template>

<script>
    import {
        selectAllBrand,selectCategory,selectModel,packTypeList,packTypeAdd,packTypeEdit,packTypeByWs,packTypeEditByWs , selectMaterialManagement,engineerPackDelete
    } from "../../api/api";
     import {getPermission} from '../../api/authRequest'
    export default {
        name: 'engineerBasicPackage',
        data() {
            const validateNumber = (rule, value, callback) => {
                if (/^99$|^(\d|[1-9]\d)$/.test(value) == false) {
                    callback(new Error("请输入一个大于0,小于99的整数"));
                }else {
                    callback();
                }
            }
            return {
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                allowExit:true,
                dislogMater:false,
                exitStatus:false,
                showText:false,
                exitHtml:'编辑',
                defaultId: '',//默认品牌Id
                activeIndex:0,
                labelPosition:'left',
                dislogbasicPackage:false,
                dialogMenuStatus: "",
                textMenu: {
                    update: "修改基础包",
                    create: "新增基础包"
                },
                basicPackageLists:[
                    // {basicPackageName:'A类基础包',initiateMode:1},
                    // {basicPackageName:'B类基础包',initiateMode:1},
                    // {basicPackageName:'C类基础包',initiateMode:-1},
                ],
                basicPackageForm:{
                    basicPackageName: '',
                    initiateMode: 1,
                    id:'',
                    status:''
                },
                basicPackageFormRules:{//validateRoleName
                    pickName: [{ required: true, message: "请输入基础包名称", trigger: "blur" }],
                },
                defaultBrandId:'',
                defaultCategoryId:'',
                defaultModelId:'',
                brandLists:'',
                categoryLists:'',
                modelLists:'',
                activeBrandIndex:0,
                activeCategoryIndex:0,
                activeModelIndex:0,
                returnData: [
                
                ],
                multipleSelection:'',
                newData:[],
                basicsAuth:{
                    packTypeAdd:false,
                    packTypeEdit:false,
                    delete_pack:false,
                    packTypeEditByWs:false
                }
               
            }
        },
        components: {
        },
        mounted () {
            this.getPackList();
            this.getBrandLists();
            this.basicsAuth.packTypeAdd= getPermission('/api/engineerPackType/packTypeAdd');
            this.basicsAuth.packTypeEdit= getPermission('/api/engineerPackType/packTypeEdit');
            this.basicsAuth.delete_pack= getPermission('/api/engineerPackType/delete_pack');
            this.basicsAuth.packTypeEditByWs= getPermission('/api/engineerPackType/packTypeEditByWs');
        },
        methods: {
            //删除工程师背包
            deleteEngineerPack(id){
                this.$confirm('确认删除吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    engineerPackDelete({id: id}).then(res => {
                        if (res.data.status==100) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            getMaterialManagementList() {
                let para={
                    brandId: this.defaultBrandId,
                    categoryId: this.defaultCategoryId,//默认品类Id
                    modelId: this.defaultModelId,//默认型号Id
                    initiateMode: 1,
                    startRow:this.pages.page,
                    pageSize:this.pages.pageSize
                }
                selectMaterialManagement(para).then(res => {
                    if (res.data.status==100) {
                        this.newData = res.data.results.list;
                        this.pages.total = res.data.results.total;
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //清空dialog
            emptyDialog(formName) {
                this.$refs[formName].resetFields();
                this.dislogbasicPackage = false
            },
            emptyNewData(){
                this.dislogMater = false
            },
            //获取基础包列表
            getPackList(){
                packTypeList().then(res => {
                    if (res.data.status==100) {
                        this.basicPackageLists = res.data.results
                        this.basicPackageForm = Object.assign({}, this.basicPackageLists[0]); //默认请求第一个基础包物料数据
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中基础包
            selectbasicPackage(item,index) {
                console.log(item)
                this.activeIndex = index
                this.basicPackageForm = Object.assign({}, item);
                let query = {
                    memo:item.id,
                    brandId:this.defaultBrandId,
                    categoryId:this.defaultCategoryId,
                    modelId:this.defaultModelId
                };
                packTypeByWs(query).then(res =>{
                    if(res.data.status == 100){
                        this.returnData = res.data.results 
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            newbasicPackage() {
                this.basicPackageForm = {
                    basicPackageName: '',
                    initiateMode: 1,
                };
                this.dislogbasicPackage = true;
                this.dialogMenuStatus = "create";
            },
            saveEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            id:this.basicPackageForm.id,
                            packName:this.basicPackageForm.packName,
                            // sort:this.brandForm.sort,
                            // initiateMode:this.brandForm.initiateMode,
                            status:this.basicPackageForm.status
                        }
                        packTypeEdit(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogbasicPackage = false;
                                this.$refs[formname].resetFields();
                                /*刷新品牌列表*/
                                this.getPackList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            addEventFormSubmitBtn(formname){
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        let para={
                            packName:this.basicPackageForm.packName,
                            status:this.basicPackageForm.status,
                        };
                        packTypeAdd(para).then(res => {
                            if (res.data.status==100) {
                                this.$message({
                                    message: res.data.message,
                                    type: "success"
                                });
                                /*关闭弹窗，重置输入框*/
                                this.dislogbasicPackage = false;
                                this.$refs[formname].resetFields();
                                /*刷新品牌列表*/
                                this.getPackList();
                            }else{
                                this.$message({
                                    message: res.data.message,
                                    type: "error"
                                });
                            }
                        }).catch((error) =>{
                            this.$Message.error(error.message);
                        })
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            },
            //编辑基础包
            exitbasicPackage(item) {
                this.dislogbasicPackage = true
                this.dialogMenuStatus = "update";
                this.basicPackageForm = Object.assign({}, item);
                // console.log(this.brandForm)
            },
            //查询品牌or获取品牌
            getBrandLists() {
                selectAllBrand().then(res => {
                    if (res.data.status==100) {
                        this.brandLists = res.data.results
                        this.defaultBrandId = res.data.results[0].brandId
                        // console.log(this.defaultBrandId)
                        this.getCategoryList(this.defaultBrandId)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中品牌
            selectBrand(item,index) {
                this.activeBrandIndex = index
                this.defaultBrandId = Object.assign({}, item).brandId
      
                this.getCategoryList(this.defaultBrandId)
                // console.log(this.defaultBrandId)
            },
            //获取品类
            getCategoryList(id){
                const brandId = id
                const brandData = {brandId:brandId}
                selectCategory(brandData).then((res) => {
                    if (res.data.status == 100) {
                        this.categoryLists = res.data.results
                        this.defaultCategoryId = res.data.results[0].categoryId;
                        this.getModelList(this.defaultBrandId,this.defaultCategoryId)
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) => {
                    this.$Message.error(error.message);
                })
            },
            //选中品类
            selectCategoryOpe(item,index) {
                this.activeCategoryIndex = index
                this.defaultCategoryId = Object.assign({}, item).categoryId
                this.getModelList(this.defaultBrandId,this.defaultCategoryId)
            },
            //获取型号
            getModelList(id1,id2){
                let para = {
                    brandId:id1,
                    categoryId:id2,
                }
                selectModel(para).then(res => {
                    if (res.data.status==100) {
                        this.modelLists = res.data.results
                        this.defaultModelId = res.data.results[0].modelId
                        if(this.basicPackageForm ==  null || this.basicPackageForm.id  ==  null ){
                            this.$message({
                                message: "请选择背包",
                                type: "error"
                            });
                    
                        }else{
                            let query = {
                                memo:this.basicPackageForm.id,
                                brandId:this.defaultBrandId,
                                categoryId:this.defaultCategoryId,
                                modelId:this.defaultModelId
                            };
                            packTypeByWs(query).then(res =>{
                                if(res.data.status == 100){
                                    this.returnData = res.data.results 
                                }else{
                                    this.$message({
                                        message: res.data.message,
                                        type: "error"
                                    });
                                }
                            }).catch((error) =>{
                                this.$Message.error(error.message);
                            })
                        }
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //选中型号
            selectModelOpe(item,index) {
                this.activeModelIndex = index
                this.defaultModelId = Object.assign({}, item).modelId

                if(this.basicPackageForm ==  null || this.basicPackageForm.id  ==  null ){
                    this.$message({
                        message: "请选择背包",
                        type: "error"
                    });
                }else{
                    let query = {
                        memo:this.basicPackageForm.id,
                        brandId:this.defaultBrandId,
                        categoryId:this.defaultCategoryId,
                        modelId:this.defaultModelId
                    };

                    packTypeByWs(query).then(res =>{
                        if(res.data.status == 100){
                            this.returnData = res.data.results 
                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            changeModel(){

            },
            //编辑物料
            exitMater(){
                if (this.exitHtml == '编辑') {
                    this.exitHtml = '保存'
                    this.showText = true
                    this.exitStatus = true
                    this.allowExit = false
                }else{
                    this.exitHtml = '编辑'
                    this.showText = false
                    this.exitStatus = false
                    this.allowExit = true
                    let param = {
                        id : this.basicPackageForm.id,
                        brandId:this.defaultBrandId,
                        categoryId:this.defaultCategoryId,
                        modelId:this.defaultModelId
                    };
                    let query = [];
                    let isNum = true;
                    for(let i = 0 ; i<this.returnData.length ; i++){
                        if(!/^[1-9]+[0-9]*$/.test(this.returnData[i].sum)){
                            isNum = false;
                        }
                        let date ={
                            packId : this.basicPackageForm.id,
                            materialCoding : this.returnData[i].materialCoding,
                            sum : this.returnData[i].sum
                        }
                        query.push(date)
                    }
                    if(!isNum){
                        this.$message({
                            message: "工程师基础包数量只能为整数",
                            type: "warning"
                        });
                        return
                    }
                    param.ptws = query;
                    packTypeEditByWs(param).then(res =>{
                        if(res.data.status == 100){
                            this.$message({
                                message: "成功",
                                type: "success"
                            });

                        }else{
                            this.$message({
                                message: res.data.message,
                                type: "error"
                            });
                        }
                    }).catch((error) =>{
                        this.$Message.error(error.message);
                    })
                }
            },
            //新建物料
            newMater(){
                this.dislogMater = true
                this.getMaterialManagementList()
            },
            //移除订单
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection)
            },
            isHava(code){
                if(this.returnData == null || this.returnData.length <= 0){
                    return false;

                }
                for(let j = 0 ; j< this.returnData.length ; j++){
                    if( this.returnData[j].materialCoding == code ){
                        return true;
                    }
                }
                return false;

            },
            addMaterSubmitBtn(){
                if(this.multipleSelection != null && this.multipleSelection.length >= 0){
                    for(let i= 0 ;i< this.multipleSelection.length ; i++){
                        if(!this.isHava(this.multipleSelection[i].materialCoding)){

                            let date = {
                                materialCode : this.multipleSelection[i].materialCode,
                                materialCoding : this.multipleSelection[i].materialCoding,
                                materialName : this.multipleSelection[i].materialName,
                                sum:1
                            };
                            this.returnData == null || this.returnData.length <= 0 ? this.returnData = [ date ] :   this.returnData.push(date)

                        }
                    }

                }
                this.dislogMater = false
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getMaterialManagementList();
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getMaterialManagementList();
            },
        },
        computed: {
        },
        watch: {
      
        }
    }
</script>

<style lang="scss" type="text/css" scoped>
    #engineerBasicPackage{
        font-size: 14px;
        .container{
            border-bottom: 1px solid #c6c6c6;
            padding: 20px 0;
            margin-bottom: 20px;
            h4{
                margin: 15px 0;
                font-weight: 500;
                font-size: 16px;
            }
            .listPart{
                width: 140px;
                float: left;
                border:1px solid #c6c6c6;
                margin:0 15px 10px 0;
                border-radius: 10px;
                height: 80px;
                line-height: 60px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                white-space: normal;
                overflow: hidden;
                text-overflow: ellipsis;
                & > span:first-child{
                    display:none;
                }
                span.active{
                    position: absolute;
                    top: -1px;
                    right:-1px;
                    display: block;
                    width: 30px;
                    height: 30px;
                    border-width: 16px;
                    border-style: solid;
                    border-color: #1abc9c #1abc9c #fff #fff;
                    border-top-right-radius:10px;
                    i{
                        position: absolute;
                        font-size: 14px;
                        color:#fff;
                        top: -9px;
                    }
                }
                span.exitBtn{
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    line-height: 20px;
                    left: 0;
                    border-top:1px solid #c6c6c6;
                    z-index:1;
                    display: block;
                }
                i.activeDelBtn{
                    display: none;
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    color: #c41335;
                }
            }
            .listPart:hover i.activeDelBtn{
                display: block;
            }
            .addContent{
                border:1px dashed #c6c6c6;
                width: 50px;
                height: 50px;
                line-height: 50px;
                float: left;
                text-align: center;
                margin-top: 15px;
                cursor: pointer;
                i{
                    font-size: 20px;
                }
            }
        }
        .container-part2{
            border-bottom: 1px solid #c6c6c6;
            .headerSpan{
                margin-right: 20px;
                display: block;
            }
            .listPart{
                border:1px solid #c6c6c6;
                margin:10px 15px 10px 0;
                border-radius: 5px;
                text-align: center;
                position: relative;
                z-index: 0;
                cursor: pointer;
                padding: 5px 10px;
            }
            li.active{
                background-color:#1abc9c;
                color:#fff;
                border-color: #1abc9c;
            }
            .el-checkbox.is-bordered+.el-checkbox.is-bordered {
                margin-left: 15px;
            }
        }
        .containerTable{
            border-color: transparent;
        }
        .toolbar{
            margin: 20px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// engineerBasicPackage.vue?32301971